__turbopack_context__.v({
  "brand-image": "one-click-checkout-button-module-scss-module__P7NJwq__brand-image",
  "one-click-checkout-button": "one-click-checkout-button-module-scss-module__P7NJwq__one-click-checkout-button",
});
